<div class="navbar">
  <a class="navbar-brand" href="https://www.supervecina.com/" name="Comunitaria">
    <img alt="Comunitaria" src="../assets/img/logo.png">
    <span>Vota</span>
  </a>
</div>
<div class="layout-wrapper p-px-2">
  <div class="p-grid w-100">
    <div class="p-col-12">
      <p-toast key="toast-top-right"></p-toast>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<!-- Footer -->
<footer class="p-mt-4">
  <div class="p-grid">
    <div class="p-col-12 left-align-mobile">
      <p-menubar class="footer-menu" [model]="footerItems"></p-menubar>
    </div>
  </div>
  <div class="p-grid">
    <div class="p-col-12 p-text-right">
      <span>@ 2021 Comunitaria</span>
    </div>
  </div>
</footer>
<!-- Cookies Banner -->
<app-cookies-banner></app-cookies-banner>
